// extracted by mini-css-extract-plugin
module.exports = {"item":"BasketItem_item__u0qBx","image":"BasketItem_image__E3IiL","unavailableImage":"BasketItem_unavailableImage__Wjw24"};